<template>
    <div class="top-menu-logout">
        <slot>
            <a :href="url" :target="isExternal() ? '_blank' : '_self'">
                <img v-if="icon" :src="icon" width="16" height="16"  /> 
                {{name}}
            </a>
        </slot>
    </div>
</template>

<script>
export default {
    props: ["name", "icon", "url"],
    components: {
    },
    mounted() {
    },
    methods: {
        isExternal() {
            const url = this.url;
            if (!url) return false;
            return url.indexOf("http") >= 0;
        },
    }
}
</script>

<style lang="scss" scoped>
    .top-menu-logout {
        cursor: pointer;
        padding-left: 24px;
        padding-top: 16px;
        border-top: solid 1px #ebebeb;

        a {
            position: relative;
            text-decoration: none;
            color: #808080;
            //font-weight: 600;
            &:hover {
                color: #6179E0;
            }
            img {
                position: relative;
                bottom: 2px;
                margin-right: 4px;
                opacity: 0.7;
            }
        }
    }

</style>

<i18n>
{
    en: {
    },
    ru: {
    }
}
</i18n>
